import 'vue-select/dist/vue-select.css';
import GestionesServices from '../services/gestion';

export default {
  data() {
    return {
      gestiones: [],
      gestionId: Number(localStorage.getItem('gestionId')) || null,
    };
  },
  computed: {
    gestion() {
      return this.gestiones?.find((gestion) => gestion.id == this.gestionId);
    },
  },
  methods: {
    async obtenerGestiones() {
      this.gestiones = [];

      const params = {
        orden_en: 'DESC',
      };

      try {
        const response = await GestionesServices.get({ params });

        this.gestiones = response.data.datos;

        if (this.gestiones.length > 0) {
          if (!this.gestionId) {
            this.setGestionId(this.gestiones[0].id);
          } else {
            this.gestionId = Number(localStorage.getItem('gestionId'));
          }
        }
      } catch (error) {
        const { mensaje } = error.response.data;

        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje,
          type: 'error',
        });
      }
    },
    setGestionId(gestionId) {
      this.gestionId = gestionId;
      localStorage.setItem('gestionId', gestionId);
    },
  },
};
